import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from './icon-definitions/icon-definitions';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {}

  public registerIcon(iconName: string, iconPath: string): void {
    this.matIconRegistry.addSvgIcon(iconName, this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath));
  }

  public registerIcons(icons: { name: string; path: string }[]): void {
    for (const icon of icons) {
      this.registerIcon(icon.name, icon.path);
    }
  }

  public initializeIcons(): void {
    this.registerIcons(ICONS);
  }
}